import React from 'react';
import PropTypes from 'prop-types';
import emptyPapersheetIcon from 'Static/images/empty-paper-sheet.svg';


const EmptyTable = ({ message }) => (
  <div style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  }}>
    <img src={emptyPapersheetIcon} alt="React Logo" style={{ marginBottom: '12px' }} />
    <h3 style={{ color: '#8295a7', fontWeight: 'bold' }}>{message}</h3>
  </div>
);

EmptyTable.defaultProps = {
  message: '',
};

EmptyTable.propTypes = {
  message: PropTypes.string,
};

export default EmptyTable;
